/* raw layout hash: _default-web-layout:082615704f274beb447aaff78653975dfd1bb18975e38e0d1a4a5667e8a3ffc7 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppNavbar from './nav/AppNavbar.jsx';
import AppFooter from './nav/AppFooter.jsx';

/**
 * Default authenticated web shell — RawHTMLDesign/layouts/_default-web-layout.html.
 * Fixed-top navbar (brand, menu, account chrome) + main content slot + footer.
 * Reused, unmodified, by every page whose page_layout node is
 * "_default-web-layout" (matched by create-frontend-layout-components).
 */
export default function DefaultWebLayout() {
  return (
    <div className="app-shell-web">
      <AppNavbar />

      <main>
        <Outlet />
      </main>

      <AppFooter />
    </div>
  );
}
